import React from 'react';

export const BoardCanvasRoot = ({
  containerRef = null,
  className = '',
  onWheel,
  onPointerDown,
  onClick,
  canvasWidth,
  canvasHeight,
  viewport,
  canvasChildren = null,
  overlayChildren = null,
  children = null,
}) => {
  const isEventFromModal = event =>
    event?.target instanceof Element &&
    Boolean(event.target.closest('[data-modal-root="true"]'));

  return (
    <div
      ref={containerRef}
      data-testid='board-canvas-root'
      className={className}
      onWheel={event => {
        if (isEventFromModal(event)) {
          return;
        }
        onWheel?.(event);
      }}
      onPointerDown={event => {
        if (isEventFromModal(event)) {
          return;
        }
        onPointerDown?.(event);
      }}
      onClick={event => {
        if (isEventFromModal(event)) {
          return;
        }
        onClick?.(event);
      }}
    >
      <div className='absolute inset-0 overflow-hidden'>
        <div
          className='absolute left-0 top-0 origin-top-left'
          style={{
            width: canvasWidth,
            height: canvasHeight,
            transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
            transformOrigin: '0 0',
          }}
        >
          {canvasChildren}
        </div>
      </div>
      {overlayChildren}
      {children}
    </div>
  );
};
